import React, { useEffect } from 'react';
import {
    TextField,
    InputAdornment,
    Paper,
    Grid,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { makeStyles } from '@mui/styles';
import CustomDialog from '../../../sharedcomponents/dialog/dialog';
import UserList from './userList';
import ButtonContainer from '../../../sharedcomponents/buttoncontainer/buttonContainer';
import Helper from '../../../utility/helper';
import { useState, Downgraded } from '@hookstate/core';
import ApiHelper from '../../../utility/ApiHelper';
import APIURLConstants from '../../../config/config';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import moment from 'moment';
import MUIDatePicker from '../../../sharedcomponents/datePicker';


const useStyles = makeStyles({
    dialogContentRoot: {
        // maxHeight: 400,
        // overflowY: 'hidden',
        '&::-webkit-scrollbar': {
            width: '5px',
            height: '5px',
            backgroundColor: '#f1f1f1',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#c1c1c1',
        },
    },
});

const UserListDialog = (props) => {
    const classes = useStyles();
    const selectedUsers = useState([]);
    const eventInfo = useState(null);
    const userInfo = useState(null);
    const [search, setSearch] = React.useState('');
    const [activityDate, setActivityDate] = React.useState(null);
    const [activityTime, setActivityTime] = React.useState(null);
    useEffect(() => {
        const userEventInfo = Helper.getStorage('eventInfo');
        const guserInfo = Helper.getStorage('userInfo');
        eventInfo.set(userEventInfo);
        userInfo.set(guserInfo);
    }, []);
    const checkSelectedUsers = (value) => {
        selectedUsers.set(value);
    };
    const loading = useState(false);
    const renderDialogContent = () => (
        <>
            <TextField
                size="small"
                fullWidth={true}
                placeholder="Search participants"
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon />
                        </InputAdornment>
                    ),
                }}
                value={search}
                onChange={(event) => setSearch(event.target.value)}
            />
            <Paper>
                <UserList
                    search={search}
                    users={props.users}
                    checkUsers={checkSelectedUsers}
                    skipEventParticipants={null}
                />
            </Paper>
            <>
                <Grid
                    container
                    lg={6}
                    md={6}
                    xs={12}
                    sx={{ width: '100%', marginTop: 4 }}>
                    <Grid item xs={10} sx={{ pr: 2 }}>
                        <MUIDatePicker
                            label="Activity Date Time"
                            value={activityDate}
                            error={false}
                            setValue={setActivityDate}
                            disabled={disabledFlag}
                        />
                        {/* <LocalizationProvider
                            dateAdapter={AdapterDateFns}>
                            <DatePicker
                                inputProps={{
                                    readOnly: true
                                }}
                                label="Activity Date Time"
                                value={activityDate}
                                onChange={(newValue) => {
                                    setActivityDate(newValue);
                                }}
                                cancelText
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        fullWidth
                                        size="small"
                                    />
                                )}
                            />
                        </LocalizationProvider> */}
                    </Grid>
                    <Grid item xs={2} sx={{ pl: 2 }}>
                        <TextField
                            id="time"
                            label="Activity Time"
                            type="time"
                            value={activityTime}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            size="small"
                            onChange={(newValue) => {
                                setActivityTime(newValue.target.value);
                            }} />
                    </Grid>
                </Grid>
            </>

        </>
    );
    const renderDialogActions = () => (
        <ButtonContainer
            handleClick={handleClick}
            handleCancel={props.handleClose}
            buttonText={'Create'}
            loading={loading.get()}
            showLoading={true}
        />
    );
    const handleClick = () => {
        if (selectedUsers.get().length == 0) {
            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select participants',
            });
            loading.set(false);
        } else if (activityDate === null) {
            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select Activity Date',
            });
            loading.set(false);
        } else if (activityTime === null) {
            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select Activity Time',
            });
            loading.set(false);
        } else {
            loading.set(true);
            let userIDs = [];
            let users = selectedUsers.attach(Downgraded).get();
            users.forEach((item) => {
                userIDs.push(item);
            });
            let activityDateTime = Helper.FormatYearDate(activityDate)+'T'+activityTime;
            
            let requestObj = {
                userIDs: userIDs.toString(),
                eventID: eventInfo.attach(Downgraded).get().eventID,
                scheduleDateTime: activityDateTime !== "" ? moment(activityDateTime).format(
                    'YYYY-MM-DDTHH:mm:ss'
                ) : null,
                modifiedBy: userInfo.attach(Downgraded).get().userID
            };
            ApiHelper.post(APIURLConstants.SET_USER_MEDIA_CIRCUIT_TIME, requestObj)
                .then((res) => {
                    if (res.data > 0) {
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'success',
                            message: 'Timing added successfully',
                        });
                        props.handleClose();
                        props.getParticipants();
                    }
                })
                .catch((error) => {
                    let message = '';
                    if (error.response && error.response.status === 401) {
                        message = 'Access denied';
                    } else {
                        message = 'Error while adding participant';
                    }
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: message,
                    });
                });
        }
    };

    return (
        <CustomDialog
            title={props.title}
            handleClose={props.handleClose}
            open={props.open}
            fullWidth={true}
            maxWidth={'sm'}
            // title={'Export Itinerary'}
            renderContent={renderDialogContent}
            renderActions={renderDialogActions}
            dialogContentClasses={{ root: classes.dialogContentRoot }}
        />
    );
};
export default UserListDialog;
